// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"03a192b4","939":"6c8b7c13"}[chunkId] + ".chunk.css";
};